/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { UserDtoModel, UserDtoModelType } from "./UserDtoModel"
import { UserDtoModelSelector } from "./UserDtoModel.base"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  createdByUser: UserDtoModelType;
}

/**
 * ServiceAccountDtoBase
 * auto generated base class for the model ServiceAccountDtoModel.
 */
export const ServiceAccountDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('ServiceAccountDto')
  .props({
    __typename: types.optional(types.literal("ServiceAccountDto"), "ServiceAccountDto"),
    id: types.identifier,
    fullname: types.union(types.undefined, types.null, types.string),
    uuid: types.union(types.undefined, types.string),
    organizationId: types.union(types.undefined, types.integer),
    createdOn: types.union(types.undefined, types.null, types.string),
    expiresOn: types.union(types.undefined, types.null, types.string),
    createdByUser: types.union(types.undefined, types.null, MSTGQLRef(types.late((): any => UserDtoModel))),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class ServiceAccountDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get fullname() { return this.__attr(`fullname`) }
  get uuid() { return this.__attr(`uuid`) }
  get organizationId() { return this.__attr(`organizationId`) }
  get createdOn() { return this.__attr(`createdOn`) }
  get expiresOn() { return this.__attr(`expiresOn`) }
  createdByUser(builder: string | UserDtoModelSelector | ((selector: UserDtoModelSelector) => UserDtoModelSelector) | undefined) { return this.__child(`createdByUser`, UserDtoModelSelector, builder) }
}
export function selectFromServiceAccountDto() {
  return new ServiceAccountDtoModelSelector()
}

export const serviceAccountDtoModelPrimitives = selectFromServiceAccountDto().fullname.uuid.organizationId.createdOn.expiresOn
